
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { LanguageProvider } from './services/LanguageContext';
import { installApiAuthInterceptor } from './services/apiClient';
import App from './App';

// NB: index.css is loaded via a <link rel="stylesheet"> in index.html, not
// imported here. With esbuild --bundle=false a `import './index.css'` survives
// into the output and the browser tries to load CSS as a JS module
// ("'text/css' is not a valid JavaScript MIME type"), which aborts the whole
// module graph and blanks the page. See docs/adr/ADR-0001.

// Attach the Firebase ID token to all /api requests before the app mounts.
installApiAuthInterceptor();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <HashRouter>
        <App />
      </HashRouter>
    </LanguageProvider>
  </React.StrictMode>
);
